<div class="take-entry-form strategy-form-section padding-bottom">

    <app-basic-indicator-form #basicIndicatorForm *ngIf="(strategyMode$ | async) !== StrategyFormBuildMode.WIZARD"
        [strategyMode$]="strategyMode$"></app-basic-indicator-form>
    <app-advance-indicator-form #advanceIndicatorForm *ngIf="(strategyMode$ | async) === StrategyFormBuildMode.WIZARD">
    </app-advance-indicator-form>
</div>